import { render, staticRenderFns } from "./BaseFieldSelect.vue?vue&type=template&id=2f4829b1&scoped=true"
import script from "./BaseFieldSelect.vue?vue&type=script&lang=js"
export * from "./BaseFieldSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldSelect.vue?vue&type=style&index=0&id=2f4829b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4829b1",
  null
  
)

export default component.exports